import React from 'react';

const ExServicemen = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold">Ex-Servicemen</h1>
      <p>This is the page for ex-servicemen.</p>
    </div>
  );
};

export default ExServicemen;
